import { Typography } from '@mui/material';
import TransText from 'next-translate/TransText';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import CustomCard from '@components/CustomCard';
import { PlainLink } from '@components/Links';
import PaywallCardSigninHeader from '@components/Paywall/PaywallCardSigninHeader';
import { CONTACT_EMAIL } from '@utils/consts/livv';

const PaywallTrialOver: FC = () => {
    const { t } = useTranslation('freemium');

    return (
        <CustomCard
            dataTestId="paywall-trial-over"
            headerContent={<PaywallCardSigninHeader />}
            mainContent={
                <Typography component="h3" mb={3} variant="h1">
                    <TransText
                        components={{
                            ContactLink: (
                                <PlainLink
                                    key="contact"
                                    href={`mailto:${CONTACT_EMAIL}`}
                                    underline="always"
                                />
                            ),
                            br: <br />,
                        }}
                        text={t('paywall.trialOver.description')}
                    />
                </Typography>
            }
            withFadeContent
        />
    );
};

export default PaywallTrialOver;
